import { HostVideo, VideoDeviceState } from '@ftr/contracts/regional-api'
import { AbstractBuilder, randomIp } from '@ftr/foundation'

export class HostVideoBuilder extends AbstractBuilder<HostVideo> {
  constructor(repeatable: boolean = false) {
    super({
      url: `rtsp://${repeatable ? '1.1.1.1' : randomIp()}:1234/test`,
      state: VideoDeviceState.Available,
    })
  }

  withDisconnectedDevice(): this {
    return this.with({
      state: VideoDeviceState.Unavailable,
    })
  }
}
